import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class CompanyProductEndpoint {
  public list(params: AxiosRequestConfig = {}) {
    return $api.get("manager/products", params);
  }

  public view(id: number) {
    return $api.get(`manager/products/${id}`);
  }

  public create(data: FormData): Promise<AxiosResponse> {
    return $api.direct({
      url: "manager/products",
      method: "POST",
      data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  public update(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.put(`manager/products/${id}`, params);
  }

  public updateImage(id: string, file) {
    const formData = new FormData();
    formData.append("image", file);

    return $api.direct({
      url: `manager/products/${id}/image`,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default CompanyProductEndpoint;
